import React, { useEffect, useState } from "react";
import profile from "../../images/profile_welcome.png";
import "../Employee/emstyle.css";
import { FaMapMarkerAlt } from "react-icons/fa";
import { Link } from "react-router-dom";
import { MdAssignmentAdd } from "react-icons/md";
import { FaRegFilePdf } from "react-icons/fa6";
import { GrView } from "react-icons/gr";
import axios from "axios";
import { usePDF } from "react-to-pdf";
import { FaRegEdit } from "react-icons/fa";
import { useDispatch } from "react-redux";
import { FallingLines } from "react-loader-spinner";
import { base_url } from "../../utils/AxiosConfig";
import { toast } from "react-toastify";
import { LuPanelLeftOpen, LuPanelRightOpen } from "react-icons/lu";
import { FaSearch } from "react-icons/fa";
import { CiViewTable } from "react-icons/ci";
import { CiGrid41 } from "react-icons/ci";
import empDetailsIcon from "../images/empDetailsIcon.png";
import user1 from "../../images/ic_no_person_photo.svg";

import InputLabel from "@mui/material/InputLabel";
import MenuItem from "@mui/material/MenuItem";
import FormControl from "@mui/material/FormControl";
import Select, { SelectChangeEvent } from "@mui/material/Select";
import Button from "@mui/material/Button";
import { useNavigate } from "react-router-dom";
import ToggleButton from "@mui/material/ToggleButton";
import ToggleButtonGroup from "@mui/material/ToggleButtonGroup";
import ViewModuleSharpIcon from "@mui/icons-material/ViewModuleSharp";
import TableViewSharpIcon from "@mui/icons-material/TableViewSharp";
import VerifiedUserSharpIcon from "@mui/icons-material/VerifiedUserSharp";
import HourglassBottomSharpIcon from "@mui/icons-material/HourglassBottomSharp";
import ic_chip_division from "../../images/ic_chip_division.svg";
import Chip from "@mui/material/Chip";
import BadgeSharpIcon from "@mui/icons-material/BadgeSharp";
import ApartmentSharpIcon from "@mui/icons-material/ApartmentSharp";

import countryList from "../../utils/country_list.json";
import {
  getReadableDateDDMMYYYY,
  getReadableDateYYYYMMDD,
} from "../../utils/utils";
import CakeTwoToneIcon from "@mui/icons-material/CakeTwoTone";
import PendingTwoToneIcon from "@mui/icons-material/PendingTwoTone";
import Popover from "@mui/material/Popover";

import List from "@mui/material/List";
import ListItem from "@mui/material/ListItem";
import ListItemText from "@mui/material/ListItemText";
import ListItemAvatar from "@mui/material/ListItemAvatar";
import Avatar from "@mui/material/Avatar";
import ic_passport_more from "../../images/ic_passport_more.svg";
import ic_visa_more from "../../images/ic_visa_more.svg";
import ic_driving_license_more from "../../images/ic_driving_license_more.svg";
import ic_insurance_more from "../../images/ic_insurance_more.svg";
import ic_emirates_id_more from "../../images/ic_emirates_id_more.svg";
import absent from "../../images/absent.svg";
import present from "../../images/present.svg";
import { getReadableTimeOnlyHourMinutes } from "../../utils/utils";
import ic_checkin_arrow from "../../images/checkin_arrow.svg";
import ic_checkout_arrow from "../../images/checkout_arrow.svg";
import ic_center_arrow from "../../images/center_arrow.svg";
import { base_url_image_view_api } from "../../utils/ImageViewingAPI";

// import Chip from '@mui/material/Chip';
import BadgeIcon from "@mui/icons-material/Badge"; // Employee ID icon
import { red } from "@mui/material/colors";

function FullEmployeeListWithAttendance({onDutyCountChange}) {
  const storedUserDataArray =
    JSON.parse(localStorage.getItem("BondTimeuserDataArray")) || [];
  let companyCode = null;

  if (storedUserDataArray) {
    companyCode = storedUserDataArray[0].cmpcode;
  }

  const [selectedEmpID, setSelectedEmpID] = useState(null);
  const [checkinCheckoutList, setCheckinCheckoutList] = useState(null);
  const [anchorEl, setAnchorEl] = React.useState(null);
  const [records, setRecords] = useState(null);

  const openImportantDatesPopover = Boolean(anchorEl);
  const idImportantDatesPopover = openImportantDatesPopover
    ? "simple-popover"
    : undefined;

  const fetchProfilePic = (ImagePath) => {
    const filePath = ImagePath.replace(/\\/g, "/");
    const fileName = filePath.split("/").pop(); // Extracts the last part (filename with extension)

    // Construct the full URL for the image
    return `${base_url_image_view_api}/BONDTIME_EMP_IMG/${fileName}`;
  };

  const handleClick = (event) => {
    setAnchorEl(event.currentTarget);
  };

  const handleClose = () => {
    setAnchorEl(null);
  };

  const callListApi = () => {
    const apiUrlPassport = `${base_url}/api/CpaysCount/${companyCode}/ATTENDANCEDAILY/-/-`;

    axios
      .get(apiUrlPassport)
      .then((res) => {
        setRecords(res.data);
        console.log("records::".res.data);
        onDutyCountChange(res.data[0]?.Cnt)
      })
      .catch((err) => {});
  };

  const callCheckinCheckoutAPI = (empId) => {
    axios
      .get(
        `${base_url}/api/CRMAttendanceDetail/CUBIX/${empId}/${getReadableDateYYYYMMDD(
          new Date()
        )}`
      )
      .then((res) => {
        setCheckinCheckoutList(res.data);
        console.log("detail records:", res.data);
      })
      .catch((err) => {});
  };

  useEffect(() => {
    callListApi();
  }, []);

  const clickedOnEmployeeCard = (empCodeFromClick) => {
    console.log("card clicked");
    callListApi();

    callCheckinCheckoutAPI(empCodeFromClick);
  };

  const [searchTerm, setSearchTerm] = useState("");

  const filteredRecords = () => {
    return records?.filter((d) =>
      d.Name?.toLowerCase().includes(searchTerm.toLowerCase())
    );
  };

  return (
  

    <div className="flex flex-col ">
      <input
        type="text"
        placeholder="Search..."
        value={searchTerm}
        onChange={(e) => setSearchTerm(e.target.value)}
        className=" mb-2 mt-1 px-4 py-2 border border-gray-300 rounded-md  focus:outline-none focus:ring-2 focus:ring-blue-500 focus:border-blue-500 text-sm"
      />
      {filteredRecords()?.map((item, index) => (
        <Link
          key={index}
          className="group p-3 rounded-lg border mb-[10px]  hover:bg-white hover:shadow-lg"
        >
          <div
            className="flex"
            onClick={() => {
              clickedOnEmployeeCard(item.EmpId);
              setSelectedEmpID(item.EmpId);
            }}
          >
            <div className="relative">
              {item.status?.toUpperCase() === "P" ? (
                <div className="group-hover:animate-bounce absolute -top-3 -left-1 flex justify-center items-center rounded-full p-[2px] bg-[#dbefdc] border border-[#7ee983]">
                  <img className="w-[14px]" src={present} alt="Present" />
                </div>
              ) : (
                <div className="group-hover:animate-bounce absolute -top-3 -left-1 flex justify-center items-center rounded-full p-[2px] bg-[#FEDFDF] border border-[#ffbaba]">
                  <img className="w-[14px]" src={absent} alt="Absent" />
                </div>
              )}

              {item.imagepath ? (
                <img
                  className="w-[80px] h-[65px] object-cover rounded-full shadow-md"
                  src={fetchProfilePic(item.imagepath)}
                  alt="Profile"
                />
              ) : (
                <img
                  className="w-[50px] h-[50px] object-cover"
                  src={user1}
                  alt="Default Profile"
                />
              )}
            </div>

            <div className="ml-2 w-full">
              <div className="flex justify-between items-center w-full">
                <p className="text-[25px]">
                  {
                    countryList.find(
                      (country) =>
                        country.name?.toLowerCase() ===
                        (item.Nationality?.toLowerCase() === "indian"
                          ? "india"
                          : item.Nationality?.toLowerCase())
                    )?.emoji
                  }
                </p>
              </div>

              <div className="flex w-full justify-between items-center">
                <span className="text-[14px] font-medium">{item.Name}</span>
                <div className="ml-2">
                  {/* <span className="text-xs px-2 py-1 bg-[#edf7f6] text-[#4db6ac] border border-[#aadfda] rounded-full">
                    {item.EmpId}
                  </span> */}

                  <Chip
                    size="small"
                    icon={
                      <BadgeIcon
                        style={{ color: "white" }}
                        className="w-3 h-3"
                      />
                    }
                    label={item.EmpId}
                    sx={{
                      backgroundColor: "#03a1fc", // bg-red-100 equivalent
                      color: "white", // White text
                      "& .MuiChip-icon": {
                        color: "white",
                      },
                    }}
                  />
                </div>
              </div>

              <div className="text-[#a0a0a0] text-sm mt-1">{item.JobTitle}</div>

              <div className="flex justify-between flex-wrap w-full mt-2">
                {item.IN_TIME && (
                  <div className="text-[#a0a0a0] text-sm">
                    <div className="flex items-center text-[#27B577]">
                      <img
                        className="w-[10px] mr-1"
                        src={ic_checkin_arrow}
                        alt="Checkin"
                      />
                      Checkin
                    </div>
                    <div className="text-right">
                      {getReadableTimeOnlyHourMinutes(item.IN_TIME)}
                    </div>
                  </div>
                )}
                {item.OUT_TIME && (
                  <div className="text-[#a0a0a0] text-sm mr-5">
                    <div className="flex items-center text-[#DF2323]">
                      <img
                        className="w-[10px] mr-1"
                        src={ic_checkout_arrow}
                        alt="Checkout"
                      />
                      Checkout
                    </div>
                    <div className="text-right">
                      {getReadableTimeOnlyHourMinutes(item.OUT_TIME)}
                    </div>
                  </div>
                )}
              </div>

              {item.Status?.toLowerCase() === "a" && (
                <div className="mt-2">
                  <span>{item.Notes}</span>
                </div>
              )}
            </div>
          </div>
          {/* <div> */}

          {selectedEmpID === item.EmpId && (
            <div className="ml-[50px] mt-2 mr-5 mb-4">
              {checkinCheckoutList?.map((item, index) => (
                <div key={index}>
                  <div
                    className={`flex ${
                      item.type?.trim().toUpperCase() === "IN"
                        ? "justify-start text-[#27B577] border-b border-dashed border-[#c3bcbc]"
                        : "justify-end text-[#DF2323]"
                    }`}
                  >
                    <span className="bg-[#f7f7f7] px-1 py-0.5">
                      {getReadableTimeOnlyHourMinutes(item.punch_time)}
                    </span>
                  </div>

                  {item.latitude && item.longitude && (
                    <div
                      className={`mt-1 ${
                        item.type?.trim().toUpperCase() === "IN"
                          ? "text-left"
                          : "text-right"
                      }`}
                    >
                      <button
                        onClick={() =>
                          window.open(
                            `https://www.google.com/maps?q=${item.latitude},${item.longitude}`,
                            "_blank"
                          )
                        }
                        className="inline-flex items-center gap-1 px-3 py-1 bg-blue-500 text-white text-xs rounded hover:bg-blue-600 transition"
                      >
                        <FaMapMarkerAlt className="text-sm" />
                        View on Map
                      </button>
                    </div>
                  )}
                </div>
              ))}
            </div>
          )}
        </Link>
      ))}
    </div>
  );
}

export default FullEmployeeListWithAttendance;
